import { ECrsStatus } from 'services/poDlt/crs';

const crsStatusSelect = [
    {
        value: ECrsStatus.STS1A,
        labelcz: 'CRS_STATUS_STS1A'
    },
    {
        value: ECrsStatus.STS1B,
        labelcz: 'CRS_STATUS_STS1B'
    },
    {
        value: ECrsStatus.STS2,
        labelcz: 'CRS_STATUS_STS2'
    },
    {
        value: ECrsStatus.STS3A,
        labelcz: 'CRS_STATUS_STS3A'
    },
    {
        value: ECrsStatus.STS3B,
        labelcz: 'CRS_STATUS_STS3B'
    },
    {
        value: ECrsStatus.STS3C,
        labelcz: 'CRS_STATUS_STS3C'
    },
    {
        value: ECrsStatus.STS3D,
        labelcz: 'CRS_STATUS_STS3D'
    },
    {
        value: ECrsStatus.STS3E,
        labelcz: 'CRS_STATUS_STS3E'
    },
    {
        value: ECrsStatus.STS4,
        labelcz: 'CRS_STATUS_STS4'
    }
];

export default crsStatusSelect;
